import { HttpClient } from "@angular/common/http";
import { AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment";
import { NzModalService, NzNotificationService } from "ng-zorro-antd";
import { DepositQREnquiryModel } from "src/app/models/deposit-qr-enquiry.model";
import { DOCSO } from "../../fieldTypes/NumToWord";
import { BookingService } from "../../services/booking.service";
import { CheckService } from "../../services/check.service";
import * as Constants from 'src/app/utils/constants';
import { DomSanitizer } from "@angular/platform-browser";

enum CHECK_TYPE {
    TTKH = 1,   // Thông tin khách hàng
    STK = 2,    // Số tài khoản
    CTBL = 3,   // Chứng thư bảo lãnh
    HDTG = 4,   // Hợp đồng tiền gửi
    EFORM = 5,  // eForm BM
    TTK = 6,    // Thẻ tiết kiệm
    EP = 7 // BM EPortal
}

@Component({
    selector: 'app-component-check',
    templateUrl: './check.component.html',
    styleUrls: ['./check.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class CheckComponent implements OnInit, AfterContentChecked {
    title = 'eFormClient';
    isMobile = window.innerWidth < 1000 ? true : false;
    globalToken: any;
    objctlDoc: any;
    code: string;
    customer: any;
    titile_page: any;
    titile: any;

    isLoading = false;
    optionRowShow: boolean;
    checkFormShow: boolean;
    products = [];
    productGroups = [];

    productGroupId: number;
    productId: number;
    nzLoadingProduct = false;

    // EFORM-CKS
    eFormUrl: any;
    qrType: number;

    // CTBL
    soSerial: string;
    soChungThuBaoLanh: string;
    ngayPhatHanh: string;
    donViQuanLyHoSo: string;
    donViKyPhathanh: string;
    nguoiKy: string;
    chucVu: string;
    soTien: string;
    soTienBangChu: string;
    benDuocBaoLanh: string;
    passportIdTaxCode: string;
    benThuHuongBaoLanh: string;
    diaChi: string;
    isShowCheckGuarantee: boolean = false;
    thoiHanBaoLanh: string;

    //HDTG
    checkForm: FormGroup;
    isShowResultDepositContract: boolean = false;
    isShowLoginDepositContract: boolean = false;
    custName: string;
    acctID: string;
    principalAmount: string;
    intRate: string;
    term: string;
    openDate: string;
    custContractStatus: string;
    branchName: string;
    customerName: string;

    //TTK
    isShowDepositQREnquiry: boolean = false;
    depositQREnquiry: DepositQREnquiryModel;

    constructor(
        private checkService: CheckService,
        private nzModal: NzModalService,
        private nzNotification: NzNotificationService,
        private activeRoute: ActivatedRoute,
        private bookingService: BookingService,
        private http: HttpClient,
        private formBuilder: FormBuilder,
        private router: Router,
        private sanitizer: DomSanitizer,
        private cdref: ChangeDetectorRef) {

    }

    ngOnInit() {
        this.activeRoute.queryParams.subscribe(
            res => {
                this.code = res['code'];
                this.qrType = res['qrtype'];
                if (this.qrType == CHECK_TYPE.TTK) {
                    this.viewDepositQREnquiry();
                } else if (this.qrType == CHECK_TYPE.EP) {
                    this.viewInfoContractEP();
                } else {
                    this.check();
                }
            }
        )

        this.checkForm = this.formBuilder.group({
            password: null,
        });
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    check() {
        if (this.code) {
            this.isLoading = true;
            this.checkService.check(this.code).subscribe(
                res => {
                    //console.log(res)
                    if (res.result && res.result.value && res.result.value.result) {
                        var result = res.result.value.result;
                        this.qrType = result.qrType;
                        if (this.qrType == CHECK_TYPE.TTKH) {
                            this.titile_page = this.sanitizer.bypassSecurityTrustHtml("ĐIỀN THÔNG TIN");
                            this.customer.CustomerIdentity = result.customerIdentity;
                            this.customer.CustomerCode = result.customerCode;
                            this.customer.CustomerName = result.customerName;
                            this.customer.DateOfBirth = result.dateOfBirth;
                            this.loadCombobox(result, this.productGroupId, this.productId);
                            this.titile = this.sanitizer.bypassSecurityTrustHtml("Chào mừng khách hàng " + this.customer.CustomerName + " !");
                            this.optionRowShow = true;
                            this.checkFormShow = true;
                        }
                        else if (this.qrType == CHECK_TYPE.CTBL) {
                            this.titile_page = this.sanitizer.bypassSecurityTrustHtml("KẾT QUẢ TÌM KIẾM");
                            this.viewGuarantee(result.cardAccount, result.qrSerial);
                        }
                        else if (this.qrType == CHECK_TYPE.HDTG) {
                            this.titile_page = this.sanitizer.bypassSecurityTrustHtml("TRA CỨU THÔNG TIN");
                            this.viewDeposit({
                                contractCode: result.cardAccount,
                                branchCode: result.branchCode
                            });
                        }
                        else if (this.qrType == CHECK_TYPE.EFORM) {
                            this.titile_page = this.sanitizer.bypassSecurityTrustHtml("TRA CỨU THÔNG TIN BIỂU MẪU");
                            this.viewEForm();
                        }
                    } else {
                        this.router.navigate([res.redirect]);
                    }
                },
                error => {
                    console.log(error);
                    this.nzNotification.error(
                        "ERROR",
                        error
                    )
                },
                () => {
                    this.isLoading = false;
                }
            )
        }
        else {
            this.router.navigate(["/error/eqrcode"]);
        }
    }

    viewInfoContractEP() {
        this.titile_page = this.sanitizer.bypassSecurityTrustHtml("TRA CỨU THÔNG TIN BIỂU MẪU");
        this.isLoading = true;
        this.checkService.getFormEPByQRCode(this.code).subscribe(
            res => {
                if (res) {
                    var data = res.data;
                    if (data == null || data == "") {
                        this.nzNotification.warning(
                            "Thông báo",
                            "Không tìm thấy dữ liệu. Vui lòng liên hệ CN/PGD phát hành để biết thêm chi tiết."
                        )
                    } else {
                        this.convertToBlob(data, 'data:application/pdf;base64', 1024);
                    }
                }
            },
            error => {
                this.nzNotification.error(
                    "ERROR",
                    error
                )
            },
            () => {
                this.isLoading = false;
            }
        )
    }

    viewDepositQREnquiry() {
        this.titile_page = this.sanitizer.bypassSecurityTrustHtml("TRA CỨU THẺ TIẾT KIỆM");
        this.isLoading = true;
        this.checkService.getDepositQREnquiry(this.code).subscribe(
            res => {
                if (res) {
                    if (res.result == null || res.result == "") {
                        if (res.respCode == Constants.IP_BLOCK_CODE && res.redirect) {
                            this.router.navigate([res.redirect]);
                        } else {
                            this.nzNotification.warning(
                                "Thông báo",
                                "Không tìm thấy dữ liệu. Vui lòng liên hệ CN/PGD phát hành để biết thêm chi tiết."
                            );
                        }
                    } else {
                        this.titile = this.sanitizer.bypassSecurityTrustHtml("TRA CỨU THÔNG TIN");
                        let dom = this.parseXml(res.result);
                        let json = this.xml2json(dom);
                        let data = JSON.parse(json);

                        if (data.DepositQREnquiry != null) {
                            this.isShowDepositQREnquiry = true;
                            this.depositQREnquiry = new DepositQREnquiryModel();
                            this.depositQREnquiry.accountStatus = data.DepositQREnquiry.AccountStatus;
                            this.depositQREnquiry.customerName = data.DepositQREnquiry.QRData?.CustomerName;
                            this.depositQREnquiry.productName = data.DepositQREnquiry.QRData?.ProductName;
                            this.depositQREnquiry.accountNumber = data.DepositQREnquiry.QRData?.AccountNumber;
                            this.depositQREnquiry.amount = data.DepositQREnquiry.QRData?.Amount ? this.formatNumber(data.DepositQREnquiry.QRData?.Amount) : "";
                            this.depositQREnquiry.currency = data.DepositQREnquiry.QRData?.Currency;
                            this.depositQREnquiry.term = data.DepositQREnquiry.QRData?.Term;
                            this.depositQREnquiry.interestRate = data.DepositQREnquiry.QRData?.InterestRate;
                            this.depositQREnquiry.createDate = data.DepositQREnquiry.QRData?.CreateDate && data.DepositQREnquiry.QRData?.CreateDate != "-" ? moment(data.DepositQREnquiry.QRData?.CreateDate, 'YYYYMMDD').format('DD/MM/YYYY') : "-";
                            this.depositQREnquiry.valueDate = data.DepositQREnquiry.QRData?.ValueDate && data.DepositQREnquiry.QRData?.ValueDate != "-" ? moment(data.DepositQREnquiry.QRData?.ValueDate, 'YYYYMMDD').format('DD/MM/YYYY') : "-";
                            this.depositQREnquiry.maturityDate = data.DepositQREnquiry.QRData?.MaturityDate && data.DepositQREnquiry.QRData?.MaturityDate != "-" ? moment(data.DepositQREnquiry.QRData?.MaturityDate, 'YYYYMMDD').format('DD/MM/YYYY') : "-";
                            this.depositQREnquiry.paymentMethod = data.DepositQREnquiry.QRData?.PaymentMethod ? data.DepositQREnquiry.QRData?.PaymentMethod : "-";
                            this.depositQREnquiry.companyName = data.DepositQREnquiry.QRData?.CompanyName;
                        }
                        else {
                            this.nzNotification.warning(
                                "WARNING",
                                "Cảnh báo : Không tìm thấy dữ liệu!"
                            );
                        }
                    }
                    this.isLoading = false;
                }
                this.isLoading = false;
            },
            error => {
                this.nzNotification.error(
                    "ERROR",
                    error
                );
                this.isLoading = false;
            },
            () => {
                this.isLoading = false;
            }
        )
    }

    viewEForm() {
        this.isLoading = true;
        this.checkService.getFormByQRCode(this.code).subscribe(
            res => {
                if (res) {
                    var data = res.data;
                    if (data == null) {
                        this.nzNotification.warning(
                            "Thông báo",
                            "Không tìm thấy dữ liệu. Vui lòng liên hệ CN/PGD phát hành để biết thêm chi tiết."
                        )
                    } else {
                        this.convertToBlob(data, 'application/pdf');
                    }
                }
            },
            error => {
                this.nzNotification.error(
                    "ERROR",
                    error
                )
            },
            () => {
                this.isLoading = false;
            }
        )
    }

    viewGuarantee(mDNo: string, serialNo: string) {
        this.titile = this.sanitizer.bypassSecurityTrustHtml("Thông tin chung của chứng thư");
        this.isShowCheckGuarantee = true;
        this.checkService.getMDRest({ mDNo: mDNo, serialNo: serialNo }).subscribe(
            res => {
                if (res) {
                    if (!res.result) {
                        this.nzNotification.error(
                            "ERROR",
                            "Lỗi : Chức năng lấy thông tin chứng thư bị lỗi! "
                        )
                    }

                    let result = res.result;
                    if (result) {
                        let dom = this.parseXml(result.response);
                        let json = this.xml2json(dom);
                        let data = JSON.parse(json);

                        if (data) {
                            if (data.GetMDInquiry.body != null) {
                                var dataValue = data.GetMDInquiry.body;
                                if (dataValue.ResCode != '000') {
                                    this.nzNotification.warning(
                                        "WARNING",
                                        "Cảnh báo : Không tìm thấy dữ liệu MD!"
                                    )
                                }
                                else {
                                    this.soSerial = dataValue.SoSerail;
                                    this.soChungThuBaoLanh = dataValue.SoChungThuBaoLanh;
                                    if (dataValue.NgayPhatHanh != "") {
                                        var ngayphathanh = dataValue.NgayPhatHanh.substring(0, 4) + "-" + dataValue.NgayPhatHanh.substring(4, 6) + "-" + dataValue.NgayPhatHanh.substring(6, 8);
                                        this.ngayPhatHanh = moment(new Date(ngayphathanh)).format('DD/MM/YYYY');
                                    }
                                    this.donViQuanLyHoSo = dataValue.DonViQuanLyHoSo;
                                    this.donViKyPhathanh = dataValue.DonViKyPhathanh;
                                    this.nguoiKy = dataValue.NguoiKy;
                                    this.chucVu = dataValue.ChucVu;
                                    this.soTien = this.formatNumber(dataValue.SoTien);
                                    this.soTienBangChu = DOCSO.doc(dataValue.SoTien);
                                    this.benDuocBaoLanh = dataValue.BenDuocBaoLanh;
                                    this.passportIdTaxCode = dataValue.IDPassportTaxCodeEstbCode;
                                    this.benThuHuongBaoLanh = dataValue.BenThuHuongBaoLanh;
                                    this.diaChi = dataValue.DiaChi;

                                    if (dataValue.MaturityDate != 0) {
                                        var thoiHanBaoLanh = dataValue.MaturityDate.substring(0, 4) + "-" + dataValue.MaturityDate.substring(4, 6) + "-" + dataValue.MaturityDate.substring(6, 8);
                                        this.thoiHanBaoLanh = moment(new Date(thoiHanBaoLanh)).format('DD/MM/YYYY');
                                    } else {
                                        this.thoiHanBaoLanh = "Theo sự kiện";
                                    }
                                }
                            }
                        }
                    } else {
                        this.nzNotification.warning(
                            "WARNING",
                            "Cảnh báo : Không tìm thấy dữ liệu MD! "
                        )
                    }
                }
            },
            error => {
                this.nzNotification.error(
                    "ERROR",
                    error
                )
            },
            () => {
                this.isLoading = false;
            }
        )
    }

    viewDeposit(obj: any) {
        this.isLoading = true;
        this.checkService.getDepositAccountDetail(obj).subscribe(
            res => {
                this.titile = this.sanitizer.bypassSecurityTrustHtml("TRA CỨU THÔNG TIN");
                this.isShowLoginDepositContract = true;
                this.isShowResultDepositContract = false;
            },
            error => {
                this.nzNotification.error(
                    "ERROR",
                    error
                )
            },
            () => {
                this.isLoading = false;
            }
        )
    }

    changeProductGroups() {
        this.nzLoadingProduct = true;
        this.products = [];
        this.bookingService.getProductsByProductGroupId(this.productGroupId).subscribe(
            res => {
                this.products = res.result.value.result;
            },
            error => {
                this.nzNotification.error(
                    'ERROR',
                    error
                )
            },
            () => {
                this.nzLoadingProduct = false;
            }
        )
    }

    loadCombobox(result: any, productGroupId: number, productId: number) {
        this.checkService.getProductGroups(productGroupId).subscribe(
            res => {
                if (res.result == null) {
                    this.nzNotification.error(
                        "ERROR",
                        "Lỗi : Chức năng lấy danh sách nhóm sản phẩm bị lỗi! "
                    )
                    return;
                }
            },
            error => {

            },
            () => {

            }
        )
    }

    convertToBlob(b64Data, contentType = '', sliceSize = 512) {
        let byteCharacters = atob(b64Data);
        let byteArrays = [];

        for (let offset = 0; offset <= byteCharacters.length; offset += sliceSize) {
            let slice = byteCharacters.slice(offset, offset + sliceSize);

            let byteNumbers = new Array(slice.length);

            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            let byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        let blob = new Blob(byteArrays, { type: contentType });
        let url = URL.createObjectURL(blob);
        this.eFormUrl = url;
    }

    loginDepositContract() {
        this.titile = this.sanitizer.bypassSecurityTrustHtml("KẾT QUẢ TÌM KIẾM");
        let password = this.checkForm.get('password').value;
        this.checkService.loginDepositContract(password).subscribe(
            res => {
                if (res) {
                    if (res.status == "FAIL") {
                        this.nzNotification.warning(
                            "WARNING",
                            "Cảnh báo : Mật khẩu không đúng!"
                        )
                    }
                    else if (res.result) {
                        var dataXml = JSON.parse(JSON.parse(res.result).Data).Value.result;
                        let dom = this.parseXml(dataXml);
                        let json = this.xml2json(dom);
                        let data = JSON.parse(json);

                        if (data.GetDepositAccountDetail.body != null) {
                            var dataValue = data.GetDepositAccountDetail.body;
                            if (dataValue.ResCode != '000') {
                                this.nzNotification.warning(
                                    "WARNING",
                                    "Cảnh báo : Không tìm thấy dữ liệu!"
                                )
                            } else {
                                this.custName = dataValue.CustName;
                                this.acctID = dataValue.AcctID;
                                this.principalAmount = this.formatNumber(dataValue.PrincipalAmount) + " (" + DOCSO.doc(dataValue.PrincipalAmount) + ")";
                                this.intRate = dataValue.IntRate + "%/năm";
                                this.term = this.converTermToVNI(dataValue.Term);
                                if (dataValue.Term != "") {
                                    var Term = dataValue.OpenDate.substring(0, 4) + "-" + dataValue.OpenDate.substring(4, 6) + "-" + dataValue.OpenDate.substring(6, 8);
                                    this.openDate = moment(new Date(Term)).format('DD/MM/YYYY');
                                }
                                this.custContractStatus = this.convertStatusDeposit(dataValue.CustContractStatus);
                                this.branchName = JSON.parse(res.result).BranchName;
                                this.customerName = JSON.parse(res.result).CustomerName;
                                this.isShowResultDepositContract = true;
                                this.isShowLoginDepositContract = false;
                            }
                        }
                    } else {
                        this.router.navigate([res.redirect]);
                    }
                }
                else {
                    this.nzNotification.warning(
                        "WARNING",
                        "Cảnh báo : Không tìm thấy dữ liệu!"
                    )
                }
            },
            error => {
                this.nzNotification.error(
                    "ERROR",
                    error
                )
            },
            () => {
                this.isLoading = false;
            }
        )
    }

    converTermToVNI(text: string) {
        if (text != null && text != "") {
            if (text.substring(text.length - 1) == "M")
                return text.substring(0, text.length - 1) + " tháng";
            else if (text.substring(text.length - 1) == "D")
                return text.substring(0, text.length - 1) + " ngày";
            else
                return text;
        }
        return "";
    }

    convertStatusDeposit(text: string) {
        if (text.toUpperCase() == "NORMAL")
            return "Đang hoạt động";
        else if (text.toUpperCase() == "CLOSED"
            || text.toUpperCase() == "TAT TOAN"
            || text.toUpperCase() == "TATTOAN")
            return "Tất toán";
        else
            return text;
    }

    parseXml(xml) { // parse string to xml
        var dom = null;
        if (window.DOMParser) {
            try {
                dom = (new DOMParser()).parseFromString(xml, "text/xml");
            }
            catch (e) { dom = null; }
        }
        else
            alert("cannot parse xml string!");
        return dom;
    }

    xml2json(xml) { // parse xml to json  http://goessner.net/download/prj/jsonxml/xml2json.js
        var X = {
            toObj: function (xml) {
                var o = {};
                if (xml.nodeType == 1) {   // element node ..
                    if (xml.attributes.length)   // element with attributes  ..
                        for (var i = 0; i < xml.attributes.length; i++)
                            o["@" + xml.attributes[i].nodeName] = (xml.attributes[i].nodeValue || "").toString();
                    if (xml.firstChild) { // element has child nodes ..
                        var textChild = 0, cdataChild = 0, hasElementChild = false;
                        for (var n = xml.firstChild; n; n = n.nextSibling) {
                            if (n.nodeType == 1) hasElementChild = true;
                            else if (n.nodeType == 3 && n.nodeValue.match(/[^ \f\n\r\t\v]/)) textChild++; // non-whitespace text
                            else if (n.nodeType == 4) cdataChild++; // cdata section node
                        }
                        if (hasElementChild) {
                            if (textChild < 2 && cdataChild < 2) { // structured element with evtl. a single text or/and cdata node ..
                                X.removeWhite(xml);
                                for (var n = xml.firstChild; n; n = n.nextSibling) {
                                    if (n.nodeType == 3)  // text node
                                        o["#text"] = X.escape(n.nodeValue);
                                    else if (n.nodeType == 4)  // cdata node
                                        o["#cdata"] = X.escape(n.nodeValue);
                                    else if (o[n.nodeName]) {  // multiple occurence of element ..
                                        if (o[n.nodeName] instanceof Array)
                                            o[n.nodeName][o[n.nodeName].length] = X.toObj(n);
                                        else
                                            o[n.nodeName] = [o[n.nodeName], X.toObj(n)];
                                    }
                                    else  // first occurence of element..
                                        o[n.nodeName] = X.toObj(n);
                                }
                            }
                            else { // mixed content
                                if (!xml.attributes.length)
                                    o = X.escape(X.innerXml(xml));
                                else
                                    o["#text"] = X.escape(X.innerXml(xml));
                            }
                        }
                        else if (textChild) { // pure text
                            if (!xml.attributes.length)
                                o = X.escape(X.innerXml(xml));
                            else
                                o["#text"] = X.escape(X.innerXml(xml));
                        }
                        else if (cdataChild) { // cdata
                            if (cdataChild > 1)
                                o = X.escape(X.innerXml(xml));
                            else
                                for (var n = xml.firstChild; n; n = n.nextSibling)
                                    o["#cdata"] = X.escape(n.nodeValue);
                        }
                    }
                    if (!xml.attributes.length && !xml.firstChild) o = null;
                }
                else if (xml.nodeType == 9) { // document.node
                    o = X.toObj(xml.documentElement);
                }
                else
                    alert("unhandled node type: " + xml.nodeType);
                return o;
            },
            toJson: function (o, name, ind) {
                var json = name ? ("\"" + name + "\"") : "";
                if (o instanceof Array) {
                    for (var i = 0, n = o.length; i < n; i++)
                        o[i] = X.toJson(o[i], "", ind + "\t");
                    json += (name ? ":[" : "[") + (o.length > 1 ? ("\n" + ind + "\t" + o.join(",\n" + ind + "\t") + "\n" + ind) : o.join("")) + "]";
                }
                else if (o == null)
                    json += (name && ":") + "null";
                else if (typeof (o) == "object") {
                    var arr = [];
                    for (var m in o)
                        arr[arr.length] = X.toJson(o[m], m, ind + "\t");
                    json += (name ? ":{" : "{") + (arr.length > 1 ? ("\n" + ind + "\t" + arr.join(",\n" + ind + "\t") + "\n" + ind) : arr.join("")) + "}";
                }
                else if (typeof (o) == "string")
                    json += (name && ":") + "\"" + o.toString() + "\"";
                else
                    json += (name && ":") + o.toString();
                return json;
            },
            innerXml: function (node) {
                var s = ""
                if ("innerHTML" in node)
                    s = node.innerHTML;
                else {
                    var asXml = function (n) {
                        var s = "";
                        if (n.nodeType == 1) {
                            s += "<" + n.nodeName;
                            for (var i = 0; i < n.attributes.length; i++)
                                s += " " + n.attributes[i].nodeName + "=\"" + (n.attributes[i].nodeValue || "").toString() + "\"";
                            if (n.firstChild) {
                                s += ">";
                                for (var c = n.firstChild; c; c = c.nextSibling)
                                    s += asXml(c);
                                s += "</" + n.nodeName + ">";
                            }
                            else
                                s += "/>";
                        }
                        else if (n.nodeType == 3)
                            s += n.nodeValue;
                        else if (n.nodeType == 4)
                            s += "<![CDATA[" + n.nodeValue + "]]>";
                        return s;
                    };
                    for (var c = node.firstChild; c; c = c.nextSibling)
                        s += asXml(c);
                }
                return s;
            },
            escape: function (txt) {
                return txt.replace(/[\\]/g, "\\\\")
                    .replace(/[\"]/g, '\\"')
                    .replace(/[\n]/g, '\\n')
                    .replace(/[\r]/g, '\\r');
            },
            removeWhite: function (e) {
                e.normalize();
                for (var n = e.firstChild; n;) {
                    if (n.nodeType == 3) {  // text node
                        if (!n.nodeValue.match(/[^ \f\n\r\t\v]/)) { // pure whitespace text node
                            var nxt = n.nextSibling;
                            e.removeChild(n);
                            n = nxt;
                        }
                        else
                            n = n.nextSibling;
                    }
                    else if (n.nodeType == 1) {  // element node
                        X.removeWhite(n);
                        n = n.nextSibling;
                    }
                    else                      // any other node
                        n = n.nextSibling;
                }
                return e;
            }
        };
        if (xml.nodeType == 9) // document node
            xml = xml.documentElement;
        var json = X.toJson(X.toObj(X.removeWhite(xml)), xml.nodeName, "\t");
        return "{" + json + "}";
    }

    formatNumber(nStr: string) {
        nStr += '';
        let x = nStr.split(',');
        let x1 = x[0];
        let x2 = x.length > 1 ? ',' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + '.' + '$2');
        }
        return x1 + x2;
    }
}